import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment"
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { MenuTypeModel } from "../models/menu-type.model";


@Injectable({
    providedIn: "root"
})
export class MenuService {

    private baseUrl: string = 'menu';
    private no: number;
    private role: number;
    menu: MenuTypeModel[] = [];
    header: MenuTypeModel[] = [];
    header_selected: MenuTypeModel = new MenuTypeModel(0, '', '', '', []);


    constructor(
        private api: ApiService
    ) {

    }

    setNo(no: number) {
        localStorage['current_menu_no'] = no;
        this.no = no;
    }

    setRole(role: number) {
        this.role = role;
    }

    getSideBarMenu() {
        let promise = new Promise((resolve, reject) => {
            if (this.no === 0) {
                this.menu = [];
                resolve(0);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}?no=${this.no}&type=${1}&role=${this.role}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.menu = res.data.map((element) => {
                            return new MenuTypeModel(element.menu_no, element.menu_option, element.route, element.icon, element.children);
                        });
                        resolve(1);
                    } else {
                        this.menu = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getHeaderBarMenu() {
        this.header = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}?no=${0}&type=${2}&role=${this.role}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.header = res.data.map((element) => {
                            return new MenuTypeModel(element.menu_no, element.menu_option, element.route, element.icon, element.children);
                        });
                        resolve(1);
                    }
                });
        });
        return promise;
    }
}